export class WebUtils {
  private static readonly TELEGRAM_IDENTIFIERS = ['TelegramWebview', 'TelegramWebviewProxy', 'TelegramWebviewProxyProto'];

  static isUsingTelegramInBuiltBrowser(): boolean {
    return this.TELEGRAM_IDENTIFIERS.filter(valueToCheck => valueToCheck in window).length > 0;
  }
}
